import TcSelect from 'components/UI/form/input/TcSelect';
import endpointUrls from 'global/Constants/endpointUrls';
import { IBackendSearchGeneric } from 'global/Models/globalModels';
import { substation } from 'global/Models/substationModel';
import { handleApiThenGeneric } from 'global/helperFunctions/handleApiThen';
import ApiService from 'global/utils/ApiService';
import { FC, useEffect, useMemo, useState } from 'react';

interface IParcelOrderSubstation {
  selectedSubstationCode?: string;
  setSubstationCode: (_id: string) => void;
}

const ParcelOrderSubstation: FC<IParcelOrderSubstation> = ({ selectedSubstationCode, setSubstationCode }) => {
  //states
  const [list, setList] = useState<substation[]>();
  const [loading, setLoading] = useState<boolean>(false);

  //effect
  useEffect(() => {
    getList();
  }, []);

  //functions
  const getList = async () => {
    setLoading(true);
    await ApiService.post(endpointUrls.substationGetAll, { recordsPerPage: 50 })
      .then((res: IBackendSearchGeneric<substation>) =>
        handleApiThenGeneric<IBackendSearchGeneric<substation>, substation[]>({
          res,
          onSuccessData: setList,
          notifFail: false,
          notifSuccess: false,
          onFailed: () => setList(undefined),
        })
      )
      .catch(() => setList(undefined));
    setLoading(false);
  };

  const options = useMemo(() => {
    return list?.map((item) => ({ label: item.title, value: item.code }));
  }, [list]);

  if (!list || list.length === 0) return null;

  return (
    <div className='flex flex-col gap-2 p-4 mb-4 border rounded-lg bg-t-bg-color border-t-border-color-base sm:flex-row sm:justify-between sm:items-center sm:gap-4'>
      <div className=''>
        <span className='block font-medium'>تعیین شعبه</span>
        <span className='block text-xs text-t-secondary-text-color'>لیست سفارش های خود را می توانید بر اساس شعب فیلتر و مدیریت کنید</span>
      </div>
      <TcSelect
        options={options}
        value={selectedSubstationCode}
        onChange={(e: any) => setSubstationCode(e?.value || undefined)}
        loading={loading}
        placeholder='تعیین شعبه ثبت کننده'
        showSearch
        allowClear
      />
    </div>
  );
};

export default ParcelOrderSubstation;
